import styled from "styled-components";

const FormFullWidth = styled.form`
	display: flex;
	flex-direction: column;
	width: 100%;
`;

export default FormFullWidth